module.exports = __webpack_public_path__ + "img/home-blue.09cc7ca6.svg";